import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ApiUrls from "../../../constants/ApiUrls";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";
import ActionTypes from "../../../constants/ActionTypes";
import { removeProductForCompare, setProductForCompare, setProductDataForCompare } from "./actions";
import { createErrorNotification } from "../notification/actions";
import { apiRequest } from "../api/actions";

export const getProductMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.COMPARE.FETCH:
    next(apiRequest(
      null,
      'GET',
      `${ApiUrls.PRODUCTS}/${action.params.manufacturer}/${action.params.productName}`,
      {
        lang: action.params.lang,
        section: action.params.section
      },
      null,
      MiddlewareEntities.COMPARE.MAIN,
      {}),
    );
    break;
  case `${MiddlewareEntities.COMPARE.MAIN} ${ActionTypes.API_SUCCESS}` :
    next(setProductDataForCompare(action.payload.data.product));
    break;
  case `${MiddlewareEntities.COMPARE.MAIN} ${ActionTypes.API_ERROR}` :
    if (action.payload.data.status !== 404) {
      next(createErrorNotification(action.payload.data,  MiddlewareEntities.COMPARE.MAIN));
    }
    break;
  }
};

export const compareSelectMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.COMPARE.CHANGE_PRODUCT:
    if (action.payload.status) {
      return next(setProductForCompare(action.payload.productId, action.payload.productType));
    }
    return next(removeProductForCompare(action.payload.productId));
  case ActionTypes.COMPARE.TOGGLE_COMPARE_DASHBOARD:
    if (action.payload === true) {
      document.body.classList.add('overflow-hidden');
    }

    if (action.payload === false) {
      document.body.classList.remove('overflow-hidden');
    }
  }
};

export const compareProductsMiddleware = [
  getProductMiddleware,
  compareSelectMiddleware
];

